import { Head } from '@inertiajs/react';
import { ArcadeScreen } from '../components/arcade-screen';
import { ChallengePrompt } from '../components/challenge-prompt';

const CHALLENGE_PROMPT = `
en platanus hack 25 (21 a 23 de nov) tenemos una máquina de arcade. podríamos poner algún juego retro, pero mucho mejor si lo podemos convertir en un desafío

MISSION
vibecodea el juego de arcade más cool

REQUIREMENTS
• usarás phaser js (librería para crear juegos web)
• el código de tu juego no puede pesar más de 50kb
• no puedes usar ningún asset externo, todo lo debes generar con código

PRIZE
• primer lugar: $250 usd en cash y un cupo asegurado para la platanus hack 25
• segundo lugar: $100 usd en cash
• ambos juegos estarán disponibles en el arcade

DEADLINE
• 10 de noviembre, 23:59 (hora chile)
  `.trim();

export default function Show() {
  return (
    <>
      <Head title="Platanus Hack 25 Arcade">
        <meta
          name="description"
          content="Vibecode the hackathon arcade, get 250 usd"
        />
      </Head>
      <div className="min-h-screen bg-black">
        <ArcadeScreen intensity="medium">
          <ChallengePrompt
            prompt={CHALLENGE_PROMPT}
            repoUrl="https://github.com/platanus-hack/platanus-hack-25-arcade/fork"
          />
        </ArcadeScreen>
      </div>
    </>
  );
}
